<div class="card">
    <div class="card-body">
        @if (entry) {
            <span [class]="badgeClass(entry.status)">{{entry.status}}</span>
        }
        @else {
            <span class="badge badge-pending">pending</span>
        }
        <div>
            <h4>
                Receivables automation
            </h4>
            <p class="subtitle">
                @if (entry) {
                    Last ran {{entry.completedAt || entry.startedAt | date:'E MMM d, yyyy h:mm:ss a'}}
                    @if (entry.asOf) {
                        for {{entry.asOf | date:'E MMM d, yyyy'}}
                    }
                    @if (entry.status === 'success') {
                        , processed {{entry.itemsProcessed | number:'1.0-0'}} item{{(entry.itemsProcessed > 1) ? 's' : ''}} in {{entry.duration | number:'1.0-0'}}ms
                    }
                    @else if (entry.status === 'failure') {
                        , {{entry.itemsFailed | number:'1.0-0'}} of {{(entry.itemsProcessed + entry.itemsFailed) | number:'1.0-0'}} item{{(entry.itemsFailed > 1) ? 's' : ''}} failed with <span class="text-danger">{{entry.errorMessage}}</span>
                    }
                }
                @else {
                    No recent receivables entries found.
                }
            </p>
        </div>
        <div class="actions">
            <button class="btn btn-sm btn-secondary" (click)="run($event)">Run</button>
        </div>
    </div>
</div>

<recompute-modal [entry]="entry" (recomputed)="recomputed($event)"></recompute-modal>
